import _ from 'underscore';
const {Backbone} = require('backboneAdapter');
import ThisModel from 'js/models/credits.history.model';
require('backbonePaginator');
require('backgrid');
require('backgridPaginator');

    export default Backbone.PageableCollection.extend({
        mode: "server",
        model: ThisModel,
        url: "/CampaignCloud/CreditsController/PaymentHistory",
        queryAttribute: '$filter',
        perPageAttribute: '$top',
        skipAttribute: '$skip',
        sortAttribute: 'sort',
        orderAttribute: '$orderby',
        formatAttribute: '$format',
        customAttribute1: '$inlinecount',
        customAttribute2: '$callback',
        firstPage: 0,
        page: 0,
        perPage: 10,
        totalPages: 25,
        sortField: 'ReleaseYear',
        sortDirection: 'asc',
        query: "",
        format: 'json',
        customParam1: 'allpages',
        customParam2: 'callback',

        parse: function (response) {
            if (!response) {
                return [];
            }
            this.totalPages = Math.ceil(response.count / this.perPage);
            this.state.lastPage = this.totalPages - 1;
            this.extras = response.extras;
            this.count = response.count;
            this.data = response.data;
            return this;
        },
        info: function () {
            var info = {
                firstPage: this.state.firstPage,
                page: this.state.currentPage,
                lastPage: this.state.lastPage,
                perPage: this.state.perPage
            };

            this.information = info;
            return info;
        },
        state: {
            pageSize: 10,
            firstPage: 0,
            page: 0
        }
    });
